import { Component } from '@angular/core';

@Component({
  selector: 'app-editor-home-navbar',
  templateUrl: 'navbar.component.html'
})
export class HomeNavbarComponent {
}

